import React, { useState, useEffect } from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import { Form, Button, Card, Alert, Spinner } from 'react-bootstrap';
import RenderizarFoto from '../components/Utils/RenderizarFoto';
import Swal from 'sweetalert2';
import { useProvider, Toast } from '../context/MenuProvider'


const ResetarSenha = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('')
  const [sucesso, setSucesso] = useState(false);
  const { site, crudAdmin } = useProvider();
  const { loading, post } = crudAdmin || {};
  const dominio = window.location.origin; 
  
  
  const handleSubmit = async (e) => {
    if(e) e.preventDefault();
    if (!email) {
      setError('Por favor, insira o email para redefinição de senha');
      return;
    }

    const resetData = {
        'email':email,
        // 'titulo_site':`${site?.name}`,
        // 'url_redefinicao':`${dominio}/login/criar-nova-senha/`
    }
    try{
      const response = await post(resetData, `/api/password-reset/`);
      if(response){
        setSucesso(true)
      }
    }catch(err){
      setError(err.response?.data?.error || err.message);
    }finally{
      
    }
  };


  return (
    <>
      <div className="col-auto col-md-5 mx-auto">
        <Card>
          <Card.Body>
            <h2 className="text-center border-dashed-bottom mb-4">{sucesso?'Redefinição de senha enviada':'Redefinição de senha'}</h2>
            <div className="text-center col-4 col-md-3 mx-auto">
              <RenderizarFoto className="img-fluid" alt="Logomarca" src={site?.favicon} />
            </div>
            {loading && <p className="text-center"><Spinner animation="border"/></p>}
            {error && !loading && <Alert variant="danger">{error}</Alert>}
            {sucesso && (
            <>
              <p>Nos te enviamos um email com instruções para configurar sua senha, se uma conta existe com o email fornecido. Você receberá a mensagem em breve.</p>
              <p>Se você não recebeu um email, por favor certifique-se que você forneceu o endereço que você está cadastrado, e verifique sua pasta de spam.</p>
            </>
            )}
            {!sucesso && (
            <>
              <p>Esqueceu sua senha? Forneça seu endereço de email abaixo, e nos te enviaremos um email com instruções para configurar uma nova.</p>
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="email" className="mb-3">
                  <Form.Label>Email:</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email de redefinição de senha"
                  />
                </Form.Group>
  
                <Button variant="secondary" type="submit" className="w-100" disabled={loading}>
                  {loading ? 'Enviando...' : 'Enviar link de redefinição'}
                </Button>
                {!loading && (
                  <div className="text-center pt-3">
                    <Link to="/login" className="btn btn-sm w-100 btn-outline-secondary">
                      Login
                    </Link>
                  </div>
                )}
              </Form>
            </>
            )}
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default ResetarSenha;